// <i18n-ignore
import urls from './urls'


export default {
    data() {
        return {
            apis: urls,
        }
    },
    methods: {
        makeUrl(url) {
            if (typeof url == 'string') {
                return this.apis[url] || url
            } else {
                let ds = url[1]
                url = this.apis[url[0]] || url
                Object.keys(ds).forEach(k => {
                    url = url.replace('{' + k + '}', ds[k])
                })
            }
            return url
        },
        checkIsLocalCart(skuid, localCartList) {
            var is = false
            localCartList.map(e => {
                if (e.skuId === skuid) {
                    is = true
                }
            })
            return is
        },
        async asyncAddCar(itemList, self, callback, type) {
            //   console.log(itemList);
            //离线购物车
            if (!self.$store.state.isLogin) {
                this.$message.warning('请登录')
                // this.$router.push('/login')
                this.$router.push('/login?redirect=' + window.location.pathname + window.location.search)
                return
            }
            if (!itemList.length) {
                return this.$message.error('加入购物车失败， 参数错误')
            }
            let flag = true
            itemList.forEach(e => {
                e.checked = 1
                // console.log(e);
                if (type == 'edit') return
                if (!e.quantity) {
                    flag = false
                    this.$message.error('加入购物车失败， 参数错误')
                }
            })
            if (!flag) return
            if (!self.$store.state.isLogin) {
                var localCartList = this.lockr.get('cartList')
                // console.log(localCartList);
                if (localCartList) {
                    // /bbb/userCenterNoAuth/shopingCarList
                    if (!localCartList.length) {
                        localCartList = itemList
                    } else {
                        localCartList.forEach((v, k) => {
                            itemList.forEach((v2, k2) => {
                                if (v2.skuId == v.skuId) {
                                    v.quantity += v2.quantity
                                } else if (!this.checkIsLocalCart(v2.skuId, localCartList)) {
                                    console.log('push')
                                    localCartList.push(v2)
                                }
                            })
                        })
                    }

                    if (!localCartList.length) {
                        return this.$message.error('加入购物车失败， 参数错误')
                    }
                    this.lockr.set('cartList', localCartList)
                } else {
                    this.lockr.set('cartList', itemList)
                }
                if (callback) {
                    callback()
                }
                !callback && self.$store.dispatch('setCartCount')
                this.$message.success('加入购物车成功')
                return
            }

            const res = await this.apiPost('bbbUserShoppingCarAdd', {
                skuGoodsList: itemList,
                shopCarBizType: 10,
            })
            const { code, message } = res || {}
            if (code !== 200) return
            itemList.forEach(item =>{
                this.addTrack('add_to_cart', {
                    userId: self.$store.state.userInfo.userId,
                    goodsId: item.goodsId,
                    quantity: item.quantity
                })
            })
            if (callback) {
                callback()
            }
            this.$message.success(message)
            !callback && self.$store.dispatch('setCartCount')
        },

        async apiPut(url, data) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .put(this.makeUrl(url), data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        resolve(error.response)
                        reject()
                    })
            })
        },

        async apiDelete(url, data) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .delete(this.makeUrl(url), { data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        const code = parseInt(error.response && error.response.status)
                        resolve(error.response)
                        if (code == 500 || code == 401) {
                            this.$message({
                                message: error.response.data.message,
                                type: 'warning',
                            })
                        }
                    })
            })
        },
    },
}
// i18n-ignore>
